import classes from './TabButton.module.css';

interface Props {
  label: string;
  onClick: () => void;
  isSelected?: boolean;
  tabStyle?: React.CSSProperties;
}

const TabButton: React.FC<Props> = ({ label, onClick, isSelected, tabStyle }) => {
  return (
    <div
      className={`${classes.appointmentDetailsTab} ${isSelected && classes.selectedAppointmentTab}`}
      onClick={onClick}
      style={isSelected ? tabStyle : undefined}
    >
      {label}
    </div>
  );
};

export default TabButton;
